import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';

export interface HasDependentChildrenProps {
  value: boolean | undefined;
  onChange: (event: any, value: boolean) => void;
}

const useStyles = makeStyles(theme => ({
  toggleGroup: {
    width: '100%',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    height: 54,
  },
  toggleButton: {
    width: '50%',
    height: 46,
  },
}));

export const HasDependentChildren = ({
  value,
  onChange,
}: HasDependentChildrenProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <ToggleButtonGroup
      className={classes.toggleGroup}
      exclusive
      value={value}
      onChange={onChange}
      size='small'>
      <ToggleButton
        className={classes.toggleButton}
        value
        aria-label='hasDependentChildren'>
        {t('label.yes')}
      </ToggleButton>
      <ToggleButton
        className={classes.toggleButton}
        value={false}
        aria-label='doesNotHaveDependentChildren'>
        {t('label.no')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
